/**
 * Генерирует случайный пароль из букв и цифр.
 * Использует криптографически стойкий генератор браузера/Node.
 * @param length — длина пароля (по умолчанию 12)
 */
export function generatePassword(length: number = 12): string {
  const alphabet =
    'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789'
  const safeLength = Math.min(32, Math.max(8, length))
  const randomValues = new Uint32Array(safeLength)
  crypto.getRandomValues(randomValues)
  let result = ''
  for (let index = 0; index < safeLength; index += 1) {
    const randomIndex = randomValues[index] % alphabet.length
    result += alphabet.charAt(randomIndex)
  }
  return result
}
